import React, { Component } from 'react';
import {
	Alert, Button,
	Col, Input, Modal, ModalBody, ModalHeader,
	Row
} from 'reactstrap';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
	getRetailAppsList,
	getRetailPackageList,
	removeAppsFromPackage,
	moveSingleAppToRetail,
	addAppsToPackage
} from '../../actions/retailActions';
import {closeAlert} from '../../actions/commonsActions';
import {connect} from 'react-redux';
import PackageSelect from './PackageSelect';
import {API_BASE_URL} from "../../helpers/constants";
import {I18n} from '../../I18n/components/packManager';

import './package-manager.css';
import noImg from '../../assets/images/img-error.svg';
import {debounce} from "../../helpers/debounce";

class PackageManager extends Component {
	constructor(props) {
		super(props);
		this.state = {
			packageSource: null,
			packageDestination: null,
			sourceApps: [],
			sourcePage: 0,
			destinationApps: [],
			destinationPage: 0,
			isOkRemoveApp: false,
			selectedAppId: null,
			selectedPackageId: null,
			checkedAppIds: [],
			sourceHasMore: true,
			destinationHasMore: true,
			sourceAppNameFilterWord: '',
			destAppNameFilterWord: ''
		}
	}

	onChangePackage = async (packageData) => {
		if ( packageData.value !== '') {
			if (packageData.name === 'packageSource') {
				this.setState({
					packageSource: packageData.value === 'ALL' ? 0 : +packageData.value,
					sourcePage: 0,
					sourceApps: []
				}, () => {
					this.fetchMoreData(packageData.name);
				})
			} else {
				this.setState({
					packageDestination: +packageData.value,
					destinationPage: 0,
					destinationApps: []
				}, () => {
					this.fetchMoreData(packageData.name);
				})
			}
		} else {
			if (packageData.name === 'packageSource') {
				this.setState({
					packageSource: 0,
					sourcePage: 0,
					sourceApps: []
				});
			} else {
				this.setState({
					packageDestination: 0,
					destinationPage: 0,
					destinationApps: []
				});
			}
		}
	};

	isOkRemoveAppToggle = (packageId, appId) => {
		this.setState({
			isOkRemoveApp: !this.state.isOkRemoveApp,
			selectedAppId: appId,
			selectedPackageId: packageId
		});
	};

	removeApp = async () => {
		let apps = [];
		try {
			if (this.state.selectedPackageId === 0) {
				await this.props.moveSingleAppToRetail(this.state.selectedAppId);
				const destinationApps = this.state.destinationApps.filter(item => item.retailMarketItemId !== this.state.selectedAppId);
				const sourceApps = 	this.state.sourceApps.filter(item => item.retailMarketItemId !== this.state.selectedAppId);
				this.setState({
					destinationApps,
					sourceApps
				})
			} else {
				await this.props.removeAppsFromPackage([this.state.selectedAppId], this.state.selectedPackageId);
				if (this.state.packageSource === this.state.selectedPackageId) {
					apps = this.state.sourceApps.filter(item => item.retailMarketItemId !== this.state.selectedAppId);
					this.setState({
						sourceApps: apps
					})
				}
				if (this.state.packageDestination === this.state.selectedPackageId) {
					apps = this.state.destinationApps.filter(item => item.retailMarketItemId !== this.state.selectedAppId);
					this.setState({
						destinationApps: apps
					})
				}
			}
			this.isOkRemoveAppToggle(null, null)
		} catch (err) {
		}
	};

	setCheckedApps = checkedAppIds => {
		this.setState({
			checkedAppIds
		});
	};

	addToPackage = async () => {
		if (this.state.checkedAppIds.length && this.state.checkedAppIds ) {
			await this.props.addAppsToPackage(this.state.checkedAppIds, this.state.packageDestination);
			const apps = await this.props.getRetailPackageList({
				packageId: this.state.packageDestination,
				page: 0
			});
			this.setState({
				checkedAppIds: [],
				destinationApps: apps.data,
				destinationHasMore: true,
				sourcePage: 0
			});
		}
	};

	fetchMoreData = async (source) => {
		let apps = [];
		let newApps = [];
		if (source === 'packageSource') {
			if (this.state.packageSource === 0) {
				apps = await this.props.getRetailAppsList({
					companyId: this.props.company.id,
					page: this.state.sourcePage,
					filter: this.state.sourceAppNameFilterWord ? this.state.sourceAppNameFilterWord : false
				})
			} else {
				apps = await this.props.getRetailPackageList({
					packageId: this.state.packageSource,
					page: this.state.sourcePage,
					filter: this.state.sourceAppNameFilterWord ? this.state.sourceAppNameFilterWord : false
				});
			}
			newApps = [...this.state.sourceApps];
		} else {
			apps = await this.props.getRetailPackageList({
				packageId: this.state.packageDestination,
				page: this.state.destinationPage,
				filter: this.state.destAppNameFilterWord ? this.state.destAppNameFilterWord: false
			});
			newApps = [...this.state.destinationApps];
		}

		apps.data.forEach(app => {
			const index = newApps.findIndex((elem) => elem.mobileAppId === app.mobileAppId);
			if (index === -1) {
				newApps.push(app);
			} else {
				newApps[index] = app;
			}
		});

		if (source === 'packageSource') {
			this.setState(state => ({
				sourceApps: newApps,
				sourceHasMore: state.sourceApps.length < newApps.length,
				sourcePage: state.sourcePage + 1
			}));
		} else {
			this.setState(state => ({
				destinationApps: newApps,
				destinationHasMore: state.destinationApps.length < newApps.length,
				destinationPage: state.destinationPage + 1
			}));
		}
	};

	isPackageChecked = selectedId => this.state.checkedAppIds.includes(selectedId);

	changeStatusCheckedApps = checkedAppId => {
		const { checkedAppIds } = this.state;
		const checkedAppIndex = checkedAppIds.findIndex(item => item === checkedAppId);
		if (checkedAppIndex !== -1) {
			checkedAppIds.splice(checkedAppIndex, 1);
			this.setState({
				checkedAppIds: checkedAppIds
			}, () => {this.setCheckedApps(this.state.checkedAppIds)});
		} else {
			this.setState(state => ({
				checkedAppIds: [...state.checkedAppIds, checkedAppId]
			}), () => {this.setCheckedApps(this.state.checkedAppIds)});
		}
	};

	clearAllCheckedApps = () => {
		this.setState({
			checkedAppIds: []
		});
	};

	debouncedFetchMoreData = debounce((source) => {
        this.fetchMoreData(source);
    }, 2000);

	filterAppByNameHandler = (value, source) => {
		if (source) {
			console.log('source', value);
			this.setState({
				sourceAppNameFilterWord: value,
				sourcePage: 0,
				sourceApps: []
			}, () => {
				this.debouncedFetchMoreData('packageSource');
			});
		} else {
			console.log('dest', value);
			this.setState({
				destAppNameFilterWord: value,
				destinationPage: 0,
				destinationApps: []
			}, () => {
                this.debouncedFetchMoreData('packageDestination');
			});
		}
	};

	generateAppList = source => {
		const apps = source === 'packageSource' ? this.state.sourceApps : this.state.destinationApps;
		return (
				<InfiniteScroll
					className=""
					dataLength={source === 'packageSource' ? this.state.sourceApps : this.state.destinationApps}
					next={source === 'packageSource' ? () => {this.fetchMoreData('packageSource')} : () => {this.fetchMoreData('packageDestination')}}
					hasMore={source === 'packageSource' ? this.state.sourceHasMore : this.state.destinationHasMore}
					loader={<div className="divider-block"></div>}
					height={300}
					endMessage={
						<div className="divider-block">
							<b>--- No more Items --- </b>
						</div>
					}
				>
					{
						apps.map(item => {
							let isRequiredForInstall = null;
							try {
								const selectedAttr =  item.mobileApp.mobileAppAttributes.filter(attr => attr.attribute.label === 'APKRequiredForInstall')[0];
								if (selectedAttr) {
									isRequiredForInstall = selectedAttr.value == 'true';
								}
							} catch (err)  {
								console.log(err)
							}
							let requiredBlockStyles = "";
							 if (source !== 'packageSource' ) {
								 if (isRequiredForInstall) {
									 requiredBlockStyles = "market-manager-list__required market-manager-list__required--sourceshow";
								 } else {
									 requiredBlockStyles = "market-manager-list__required";
								 }
							 } else {
								 if (isRequiredForInstall) {
									 requiredBlockStyles = "market-manager-list__required market-manager-list__required--show";
								 } else {
									 requiredBlockStyles = "market-manager-list__required";
								 }
							 }

							return (
								<div
									className={source !== 'packageSource' ?
										"market-manager-list__app " : "market-manager-list__app market-manager-list__app--source"}
									key={item.mobileApp.id}
									onClick={(e) => {
										e.stopPropagation();
										this.changeStatusCheckedApps(item.retailMarketItemId)
									}}
								>
									{
										source === 'packageSource' ? (
											<input
												className=""
												type="checkbox"
												checked={this.isPackageChecked(item.retailMarketItemId)}
											/>
										) : ""
									}
									<span className={requiredBlockStyles} title={I18n[this.props.lang].required}></span>
									<img
										src={`${API_BASE_URL}/apps/mobileapps/download/icon/${item.mobileApp.id}`}
										alt="application logotype"
										className="img-fluid mr-2 media-object"
										width="30"
										onError={(e) => {
											e.target.onerror = null;
											e.target.src = noImg
										}}

									/>
									<span>{item.mobileApp.appLabel}</span>
									<div className="text-center">
										<button
											type="button"
											className="close"
											aria-label="Close"
											onClick={(e) => {
												e.stopPropagation();
												if (source === 'packageSource') {
													this.isOkRemoveAppToggle(this.state.packageSource, item.retailMarketItemId)
												} else {
													this.isOkRemoveAppToggle(this.state.packageDestination, item.retailMarketItemId)
												}
											}}
										>
											<span aria-hidden="true">×</span>
										</button>
									</div>
								</div>
							);
						})
					}
				</InfiniteScroll>
		)
	};

	render() {
		const {lang} = this.props;
		const packages = this.props.filteredPackages || this.props.packages;
		return (
			<div className="package-manager">
				<Alert
					color={`${this.props.alert.alert.status}`}
					isOpen={this.props.alert.isOpen || false}
				>
					{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
				</Alert>
				<Modal className="remove-app-modal" isOpen={this.state.isOkRemoveApp} toggle={this.isOkRemoveAppToggle}>
					<ModalHeader>{I18n[lang].sure}</ModalHeader>
					<ModalBody>
						<Button color="secondary" className="ml-1" onClick={() => {this.isOkRemoveAppToggle(null, null)}}>{I18n[lang].cancel}</Button>
						<Button color="danger" className="ml-1" onClick={this.removeApp}>{I18n[lang].delete}</Button>
					</ModalBody>
				</Modal>
				<Row>
					<Col sm="12" lg="6">
						<div className="package-manager__top">
							<h5>{I18n[lang].source}</h5>
							<div className="apps__select-action">
								<Button
									outline
									size="sm"
									className={`btn btn-secondary ${this.state.checkedAppIds.length ? 'visible' : 'invisible'}`}
									onClick={this.clearAllCheckedApps}
								>{I18n[lang].clearSelection}
								</Button >
							</div>
						</div>
						<PackageSelect
							packages={packages.filter(item => item.id !== this.state.packageDestination)}
							onChangePackage={this.onChangePackage}
							view="packageSource"
						/>
						<Input
							className={this.state.packageSource === 0 || this.state.packageSource ?
								"package-manager__search" : "package-manager__search package-manager__search--hide"}
							type="text"
							name="search"
							id="search"
							placeholder={I18n[this.props.lang].searchPlaceholder}
							value={this.state.sourceAppNameFilterWord}
							onChange={event => {
								this.filterAppByNameHandler(event.target.value, true)}}
						/>
						{this.generateAppList("packageSource")}
					</Col>
					<Col sm="12" lg="6">
						<h5 className="package-manager__destination-title">{I18n[lang].destination}</h5>
						<PackageSelect
							packages={packages.filter(item => item.id !== this.state.packageSource)}
							onChangePackage={this.onChangePackage}
							view="packageDestination"
						/>
						<Input
							className={this.state.packageDestination ?
								"package-manager__search" : "package-manager__search package-manager__search--hide"}
							type="text"
							name="search"
							id="search"
							placeholder={I18n[this.props.lang].searchPlaceholder}
							value={this.state.destAppNameFilterWord}
							onChange={event => {
								this.filterAppByNameHandler(event.target.value, false)}}
						/>
						{this.generateAppList("packageDestination")}
					</Col>
				</Row>
				<div className="package-manager__buttons">
					<Button color="secondary" className="ml-1" onClick={this.props.close}>{I18n[lang].cancel}</Button>
					<Button
						color="primary"
						className="ml-1"
						onClick={this.addToPackage}
						disabled={ (!this.state.sourceApps.length || (!this.state.destinationApps.length && !this.state.checkedAppIds.length)) }
					>
						{I18n[lang].save}
					</Button>
				</div>
			</div>
		)
	}

}

const mapDispatchToProps = dispatch => {
	return {
		getRetailAppsList: query => dispatch(getRetailAppsList(query)),
		closeAlert: () => dispatch(closeAlert()),
		getRetailPackageList: (query) => dispatch(getRetailPackageList(query)),
		moveSingleAppToRetail: appId => dispatch(moveSingleAppToRetail(appId)),
		removeAppsFromPackage: (appIds, packageId) => dispatch(removeAppsFromPackage(appIds, packageId)),
		addAppsToPackage: (appIds, packageId) => dispatch(addAppsToPackage(appIds, packageId)),

	};
};

const mapStateToProps = state => ({
	alert: state.alert,
	retailApps: state.retailAppsList.retailApps,
	company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
	packageApps: state.retailPackageAppsList.packageApps,
	filteredPackages: state.filteredPackages.filteredPackages,
	packages: state.packagesList.packages,
	lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(PackageManager)



// WEBPACK FOOTER //
// ./src/components/PackageManager/PackageManager.js